import { TPersonalDataApplicationsStore } from './types.ts';

export const personalDataApplicationsState: TPersonalDataApplicationsStore = {
  publicLink: '',
  applicationDocumentId: '',
  formData: null,
  appId: '',
  documentStatus: null,
  fileURL: null,
  docId: null,

  loading: false,
  error: null,
  status: '',

  // --------------------------
  pendingApplicationForm: false,
  applicationForm: null,

  pendingPostApplicationForm: false,
  applicationPostForm: null,

  signing: {
    applicationId: null,

    isSigning: false,
    isLoading: false,

    cloudKeyQRVerificationURL: 'https://',
    isCloudKeyQRVerificationModalOpen: false,

    IITHashes: [],

    IITSigns: [],
    isIITSignsLoaded: false,

    isPrivateKeyLoaded: false,

    error: null,
    hasError: false,
  },

  pendingValidateDocumentSign: false,
  postValidateDocumentSign: null,

  pendingRevokeApplicationForm: false,
  applicationRevokeForm: null,

  pendingPersonalDataTableSubmit: false,
  personalDataTableSubmit: null,

  pendingPersonalDataTableRevoke: false,
  personalDataTableRevoke: null,
};
